import { combineReducers } from "redux";

import authReducer from "./Auth";
import usersReducer from "./user";
import departmentReducer from "./department";
import categoryReducer from "./category";
import claimReducer from "./claim";
import verificationReducer from "./verification";
import pendingsReducer from "./pendingClaims";
import locationsReducer from "./locations";
import approvedClaimsReducer from "./Approved";
import limitReducer from "./claimLimit";
import payClaimReducer from "./payClaim";
import branchStatsReducer from "./branchStats";
import adminStatsReducer from "./adminStats";
import unpaidClaims from "./unpaidClaims";
export default combineReducers({
  auth: authReducer,
  users: usersReducer,
  departments: departmentReducer,
  category: categoryReducer,
  claims: claimReducer,
  verification: verificationReducer,
  pendingClaims: pendingsReducer,
  locations: locationsReducer,
  approved: approvedClaimsReducer,
  limit: limitReducer,
  pay: payClaimReducer,
  branchStats: branchStatsReducer,
  adminStats: adminStatsReducer,
  unpaidClaims,
});
